import { useTranslation } from 'react-i18next'

export default function AgentsSvg() {
  const { t } = useTranslation()
  const a = (key: string) => t(`caseScoder.agentFlow.${key}`)

  return (
    <svg
      className="w-full h-auto max-w-[1180px] mx-auto block"
      viewBox="0 0 1200 540"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="agentShadow" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="3" stdDeviation="4" floodColor="#1B2B3A" floodOpacity="0.12" />
        </filter>
        <marker
          id="agentArrow"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="6"
          markerHeight="6"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#4A5E6D" />
        </marker>
        <style>{`
          .agent-orch { font-family: 'Manrope', sans-serif; font-size: 14px; font-weight: 700; fill: #FFFFFF; }
          .agent-orch-sub { font-family: 'Inter', monospace; font-size: 9px; fill: #80D3C9; font-weight: 600; letter-spacing: 1px; }
          .agent-dir { font-family: 'Manrope', sans-serif; font-size: 13px; font-weight: 700; fill: #FFFFFF; }
          .agent-dir-sub { font-family: 'Inter', monospace; font-size: 8px; fill: rgba(255,255,255,0.7); font-weight: 600; letter-spacing: 0.8px; }
          .agent-sub { font-family: 'Manrope', sans-serif; font-size: 12px; font-weight: 600; fill: #1B2B3A; }
          .agent-sub-tag { font-family: 'Inter', monospace; font-size: 8px; fill: #007D6E; font-weight: 600; letter-spacing: 0.6px; }
        `}</style>
      </defs>

      {/* Orchestrator */}
      <g transform="translate(515, 20)">
        <rect
          width="170"
          height="80"
          rx="10"
          fill="#1B2B3A"
          stroke="#007D6E"
          strokeWidth="2"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 16)"
          stroke="#80D3C9"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 18h18M5 18l-1-9 5 4 3-7 3 7 5-4-1 9" />
        </g>
        <text x="48" y="32" className="agent-orch-sub">
          {a('orchestratorTag')}
        </text>
        <text x="48" y="55" className="agent-orch">
          {a('orchestratorLine1')}
        </text>
        <text x="48" y="71" className="agent-orch">
          {a('orchestratorLine2')}
        </text>
      </g>

      {/* Connectors */}
      <line x1="600" y1="100" x2="600" y2="140" stroke="#4A5E6D" strokeWidth="2" />
      <line x1="200" y1="140" x2="1000" y2="140" stroke="#4A5E6D" strokeWidth="2" />
      <line
        x1="200"
        y1="140"
        x2="200"
        y2="178"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#agentArrow)"
      />
      <line
        x1="600"
        y1="140"
        x2="600"
        y2="178"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#agentArrow)"
      />
      <line
        x1="1000"
        y1="140"
        x2="1000"
        y2="178"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#agentArrow)"
      />

      {/* Director: Tecnologia */}
      <g transform="translate(115, 180)">
        <rect
          width="170"
          height="75"
          rx="10"
          fill="#00A693"
          stroke="#007D6E"
          strokeWidth="2"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#FFFFFF"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 18h18M5 18l-1-9 5 4 3-7 3 7 5-4-1 9" />
        </g>
        <text x="48" y="30" className="agent-dir-sub">
          {a('directorTag')}
        </text>
        <text x="48" y="51" className="agent-dir">
          {a('dirTechLine1')}
        </text>
        <text x="48" y="66" className="agent-dir">
          {a('dirTechLine2')}
        </text>
      </g>

      {/* Director: Financeiro */}
      <g transform="translate(515, 180)">
        <rect
          width="170"
          height="75"
          rx="10"
          fill="#00A693"
          stroke="#007D6E"
          strokeWidth="2"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#FFFFFF"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 18h18M5 18l-1-9 5 4 3-7 3 7 5-4-1 9" />
        </g>
        <text x="48" y="30" className="agent-dir-sub">
          {a('directorTag')}
        </text>
        <text x="48" y="58" className="agent-dir">
          {a('dirFinLine1')}
        </text>
      </g>

      {/* Director: Delivery */}
      <g transform="translate(915, 180)">
        <rect
          width="170"
          height="75"
          rx="10"
          fill="#00A693"
          stroke="#007D6E"
          strokeWidth="2"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#FFFFFF"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 18h18M5 18l-1-9 5 4 3-7 3 7 5-4-1 9" />
        </g>
        <text x="48" y="30" className="agent-dir-sub">
          {a('directorTag')}
        </text>
        <text x="48" y="51" className="agent-dir">
          {a('dirDelLine1')}
        </text>
        <text x="48" y="66" className="agent-dir">
          {a('dirDelLine2')}
        </text>
      </g>

      {/* Connectors: Tecnologia -> 2 sub-agents */}
      <line x1="200" y1="255" x2="200" y2="285" stroke="#4A5E6D" strokeWidth="1.5" />
      <line x1="120" y1="285" x2="280" y2="285" stroke="#4A5E6D" strokeWidth="1.5" />
      <line
        x1="120"
        y1="285"
        x2="120"
        y2="320"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#agentArrow)"
      />
      <line
        x1="280"
        y1="285"
        x2="280"
        y2="320"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#agentArrow)"
      />

      {/* Connectors: Financeiro -> 3 sub-agents */}
      <line x1="600" y1="255" x2="600" y2="285" stroke="#4A5E6D" strokeWidth="1.5" />
      <line x1="460" y1="285" x2="740" y2="285" stroke="#4A5E6D" strokeWidth="1.5" />
      <line
        x1="460"
        y1="285"
        x2="460"
        y2="320"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#agentArrow)"
      />
      <line
        x1="600"
        y1="285"
        x2="600"
        y2="320"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#agentArrow)"
      />
      <line
        x1="740"
        y1="285"
        x2="740"
        y2="320"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#agentArrow)"
      />

      {/* Connectors: Delivery -> 1 sub-agent */}
      <line
        x1="1000"
        y1="255"
        x2="1000"
        y2="320"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#agentArrow)"
      />

      {/* Sub-agent: Gerente de Projetos */}
      <g transform="translate(45, 322)">
        <rect
          width="150"
          height="75"
          rx="10"
          fill="#FFFFFF"
          stroke="#00A693"
          strokeWidth="1.8"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#007D6E"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <circle cx="12" cy="5" r="2" />
          <line x1="12" y1="7" x2="12" y2="11" />
          <line x1="8" y1="16" x2="8" y2="16.01" />
          <line x1="16" y1="16" x2="16" y2="16.01" />
        </g>
        <text x="46" y="30" className="agent-sub-tag">
          {a('subAgentTag')}
        </text>
        <text x="46" y="51" className="agent-sub">
          {a('subPmLine1')}
        </text>
        <text x="46" y="66" className="agent-sub">
          {a('subPmLine2')}
        </text>
      </g>

      {/* Sub-agent: Líder Técnico */}
      <g transform="translate(205, 322)">
        <rect
          width="150"
          height="75"
          rx="10"
          fill="#FFFFFF"
          stroke="#00A693"
          strokeWidth="1.8"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#007D6E"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <circle cx="12" cy="5" r="2" />
          <line x1="12" y1="7" x2="12" y2="11" />
          <line x1="8" y1="16" x2="8" y2="16.01" />
          <line x1="16" y1="16" x2="16" y2="16.01" />
        </g>
        <text x="46" y="30" className="agent-sub-tag">
          {a('subAgentTag')}
        </text>
        <text x="46" y="58" className="agent-sub">
          {a('subTechLine1')}
        </text>
      </g>

      {/* Sub-agent: Contas a Pagar */}
      <g transform="translate(385, 322)">
        <rect
          width="150"
          height="75"
          rx="10"
          fill="#FFFFFF"
          stroke="#00A693"
          strokeWidth="1.8"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#007D6E"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <circle cx="12" cy="5" r="2" />
          <line x1="12" y1="7" x2="12" y2="11" />
          <line x1="8" y1="16" x2="8" y2="16.01" />
          <line x1="16" y1="16" x2="16" y2="16.01" />
        </g>
        <text x="46" y="30" className="agent-sub-tag">
          {a('subAgentTag')}
        </text>
        <text x="46" y="51" className="agent-sub">
          {a('subApLine1')}
        </text>
        <text x="46" y="66" className="agent-sub">
          {a('subApLine2')}
        </text>
      </g>

      {/* Sub-agent: Contas a Receber */}
      <g transform="translate(525, 322)">
        <rect
          width="150"
          height="75"
          rx="10"
          fill="#FFFFFF"
          stroke="#00A693"
          strokeWidth="1.8"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#007D6E"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <circle cx="12" cy="5" r="2" />
          <line x1="12" y1="7" x2="12" y2="11" />
          <line x1="8" y1="16" x2="8" y2="16.01" />
          <line x1="16" y1="16" x2="16" y2="16.01" />
        </g>
        <text x="46" y="30" className="agent-sub-tag">
          {a('subAgentTag')}
        </text>
        <text x="46" y="51" className="agent-sub">
          {a('subArLine1')}
        </text>
        <text x="46" y="66" className="agent-sub">
          {a('subArLine2')}
        </text>
      </g>

      {/* Sub-agent: Auxiliar Financeiro */}
      <g transform="translate(665, 322)">
        <rect
          width="150"
          height="75"
          rx="10"
          fill="#FFFFFF"
          stroke="#00A693"
          strokeWidth="1.8"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#007D6E"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <circle cx="12" cy="5" r="2" />
          <line x1="12" y1="7" x2="12" y2="11" />
          <line x1="8" y1="16" x2="8" y2="16.01" />
          <line x1="16" y1="16" x2="16" y2="16.01" />
        </g>
        <text x="46" y="30" className="agent-sub-tag">
          {a('subAgentTag')}
        </text>
        <text x="46" y="51" className="agent-sub">
          {a('subFinLine1')}
        </text>
        <text x="46" y="66" className="agent-sub">
          {a('subFinLine2')}
        </text>
      </g>

      {/* Sub-agent: Entregas */}
      <g transform="translate(925, 322)">
        <rect
          width="150"
          height="75"
          rx="10"
          fill="#FFFFFF"
          stroke="#00A693"
          strokeWidth="1.8"
          filter="url(#agentShadow)"
        />
        <g
          transform="translate(14, 14)"
          stroke="#007D6E"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <circle cx="12" cy="5" r="2" />
          <line x1="12" y1="7" x2="12" y2="11" />
          <line x1="8" y1="16" x2="8" y2="16.01" />
          <line x1="16" y1="16" x2="16" y2="16.01" />
        </g>
        <text x="46" y="30" className="agent-sub-tag">
          {a('subAgentTag')}
        </text>
        <text x="46" y="58" className="agent-sub">
          {a('subDelLine1')}
        </text>
      </g>
    </svg>
  )
}
